import * as React from "react";

/** Aligns with docs/product/frontend-visual-foundation.md responsive table. */
export const MOBILE_BREAKPOINT = 768;
export const NARROW_DESKTOP_BREAKPOINT = 1280;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}

/** True when document workspace should collapse side rails (tablet / narrow desktop). */
export function useIsNarrowDesktop() {
  const [isNarrow, setIsNarrow] = React.useState(false);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${NARROW_DESKTOP_BREAKPOINT - 1}px)`);
    const onChange = () => setIsNarrow(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isNarrow;
}
